"use client";

import { useState, useEffect, useCallback } from "react";

interface DetectedWallet {
  rdns: string;
  name: string;
  icon?: string;
}

interface WalletDetectResult {
  wallets: DetectedWallet[];
  isDetected: (rdns: string) => boolean;
  isLoading: boolean;
}

export function useWalletDetect(): WalletDetectResult {
  const [wallets, setWallets] = useState<DetectedWallet[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") {
      setIsLoading(false);
      return;
    }

    const detected: DetectedWallet[] = [];

    const handleAnnouncement = (event: CustomEvent) => {
      const { info } = event.detail;
      if (info?.rdns && !detected.some((w) => w.rdns === info.rdns)) {
        detected.push({
          rdns: info.rdns,
          name: info.name,
          icon: info.icon,
        });
        setWallets([...detected]);
      }
    };

    window.addEventListener(
      "eip6963:announceProvider",
      handleAnnouncement as EventListener,
    );
    window.addEventListener(
      "eip6963:crossAnnounceProvider",
      handleAnnouncement as EventListener,
    );

    window.dispatchEvent(new Event("eip6963:requestProvider"));
    window.dispatchEvent(new Event("eip6963:crossRequestProvider"));

    const timeout = setTimeout(() => setIsLoading(false), 500);

    return () => {
      window.removeEventListener(
        "eip6963:announceProvider",
        handleAnnouncement as EventListener,
      );
      window.removeEventListener(
        "eip6963:crossAnnounceProvider",
        handleAnnouncement as EventListener,
      );
      clearTimeout(timeout);
    };
  }, []);

  const isDetected = useCallback(
    (rdns: string) => wallets.some((w) => w.rdns === rdns),
    [wallets],
  );

  return { wallets, isDetected, isLoading };
}
